import React from 'react';

export interface GridEditorProps {
  render: () => React.ReactNode;
}

const GridEditor: React.FC<GridEditorProps> = ({ render }) => {
  return <>{render()}</>;
};

export default GridEditor;
